import PropTypes from "prop-types";

import "../styles/GoldenRod.scss";

/**
 * Display a blast message
 * @name GoldenRod
 * @param {string} bodyText
 * @param {string} Headline
 * @returns {JSX.Element}
 */
const GoldenRod = ({ bodyText, headline }) => {
    return (
        <div className="golden-rod">
            {headline && <div className="headline">{headline}</div>}
            {bodyText && <div className="body">{bodyText}</div>}
        </div>
    );
};

GoldenRod.propTypes = {
    bodyText: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    headline: PropTypes.string
};

GoldenRod.defaultProps = {
    bodyText: null,
    headline: null
};

export default GoldenRod;
